import './media.scss';

import Media from './Media';

export default Media;
